import axios, {AxiosInstance, AxiosRequestConfig} from 'axios';
import {useAuth0} from '@auth0/auth0-react';

const axiosConfig = {
  //withCredentials: true,
  baseURL: process.env.REACT_APP_API_URL,
  headers: {Accept: 'application/json'},
};

//export const http = axios.create(axiosConfig);

// auth0 middleware
export const useAxios = (
  {
    axiosRequestConfig,
    useAuth = true,
  }: {
    axiosRequestConfig?: AxiosRequestConfig;
    useAuth?: boolean;
  } = {
    useAuth: true,
  }
): AxiosInstance => {
  const config = {...axiosConfig, ...(axiosRequestConfig || {})};
  const {getAccessTokenSilently} = useAuth0();
  const instance = axios.create(config);
  const isLiveTest = process.env.REACT_APP_LIVE_TEST === 'true';

  if (useAuth && !isLiveTest) {
    instance.interceptors.request.use(async config => {
      const token = await getAccessTokenSilently();

      config.headers.Authorization = `Bearer ${token}`;

      return config;
    });
  }

  // Add project_id header if available
  // Read from sessionStorage which is kept in sync by ProjectContext
  instance.interceptors.request.use(config => {
    const projectId = sessionStorage.getItem('project_id');
    if (projectId) {
      config.headers.set('x-project-id', projectId);
    }

    return config;
  });

  return instance;
};
